import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fetchEpisodes = async () => {
    const res = await axios.get(`${API}/episodes`);
    return res.data;
};

export const sendSubmission = async (payload) => {
    const res = await axios.post(`${API}/submissions`, payload);
    return res.data;
};

export const login = async (email, password) => {
    const res = await axios.post(
        `${API}/auth/login`,
        { email, password },
        { withCredentials: true }
    );
    return res.data;
};

export const fetchMe = async () => {
    const res = await axios.get(`${API}/auth/me`, { withCredentials: true });
    return res.data;
};

export const logout = async () => {
    await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
};

export const fetchSubmissions = async () => {
    const res = await axios.get(`${API}/submissions`, { withCredentials: true });
    return res.data;
};

export const fetchEpisode = async (id) => {
    const res = await axios.get(`${API}/episodes/${id}`);
    return res.data;
};

export const createEpisode = async (payload) => {
    const res = await axios.post(`${API}/episodes`, payload, { withCredentials: true });
    return res.data;
};

export const updateEpisode = async (id, payload) => {
    const res = await axios.put(`${API}/episodes/${id}`, payload, { withCredentials: true });
    return res.data;
};

export const fetchContent = async () => {
    const res = await axios.get(`${API}/content`);
    return res.data;
};

export const saveSettings = async (settings) => {
    const res = await axios.put(
        `${API}/content/settings`,
        { settings },
        { withCredentials: true }
    );
    return res.data;
};

export const addPressAsset = async (payload) => {
    const res = await axios.post(`${API}/content/press-assets`, payload, { withCredentials: true });
    return res.data;
};

export const deletePressAsset = async (id) => {
    const res = await axios.delete(`${API}/content/press-assets/${id}`, { withCredentials: true });
    return res.data;
};

export const uploadFile = async (file) => {
    const form = new FormData();
    form.append("file", file);
    const res = await axios.post(`${API}/upload`, form, { withCredentials: true });
    return res.data;
};

export const fileUrl = (url) =>
    url && url.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url;

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
